import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import EventApi from '../../../../Api/EventApi';
import { getEventByIdFromSession, getResponseError } from '../../../../Api/Utils/apiUtils';
import AddBudgetItem from '../../../../Components/Accounts/AddBudgetItem/AddBudgetItem';
import ManageBudgetCard from '../../../../Components/Accounts/ManageBudgetCard/ManageBudgetCard';
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert';
import Section from '../../../../Components/Section/Section';
import './../../../../Components/Accounts/ManageBudgetCard/ManageBudgetCard.css'

const ManageBudgetComponent = () => {
    const { eventid } = useParams()
    const [isAdding, setisAdding] = useState(false);
    const [previewBudget, setpreviewBudget] = useState(0);
    const [errorMessage, seterrorMessage] = useState(null);
    const [budgetItemList, setbudgetItemList] = useState([]);
    const [reloader, setreloader] = useState(0);

    useEffect(() => {
        const loadbudget = () =>{
            const response = getEventByIdFromSession(parseInt(eventid))
            setpreviewBudget(response.Budget)
        }
        loadbudget()
        const loadBudgetitems = async () => {
            const respons = await EventApi.getBudget(parseInt(eventid))
            const responseApiError = getResponseError(respons)
            if (responseApiError) {
                seterrorMessage(responseApiError)
            }else{
                const itemList = respons.objectVal
                setbudgetItemList(itemList)
            }
        }
        loadBudgetitems()
    }, [eventid, reloader]);
    
    function goDefault() {
        setTimeout(() => {
            setreloader(0)
        }, 500);
    }

    const insertItem = async (data) => {
        const response = await EventApi.addBudgetItem(data)
        const responseApiError = getResponseError(response)
        if (responseApiError) {
                seterrorMessage(responseApiError)
        }else{
            if (response.success === 'true') {
                setreloader(2)
                goDefault()
                setisAdding(false)
            }
        }
    }

    return (
        <>
        {isAdding ? 
        <AddBudgetItem saveitem={insertItem} cancleItem={setisAdding} eventID={parseInt(eventid)} />
        :
        <Section>
            <Container>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <div className="event-budget-container">
                    <ManageBudgetCard estBudget={previewBudget} listItem={budgetItemList} />
                    <div className="add-task-button" onClick={() => setisAdding(true)}>
                        <FontAwesomeIcon icon={faPlus} />
                    </div>
                </div>
            </Container>
        </Section>
        }
        </>
    );
};

export default ManageBudgetComponent;
